<!-- Loading skeleton until business/details arrives -->
<div class="ac-card ac-pad" *ngIf="!business" aria-busy="true" aria-label="Loading admin tools">
  <div class="sk sk-title"></div>
  <div class="sk-head">
    <div class="sk sk-icon"></div>
    <div class="sk-col">
      <div class="sk sk-line" style="width: 70%"></div>
      <div class="sk sk-pct"></div>
    </div>
  </div>
  <div class="sk sk-track"></div>
  <div class="sk sk-button"></div>
</div>

<ng-container *ngIf="business">

  <!-- Profile Completion -->
  <div class="ac-card ac-pad-lg">
    <div class="ac-title">Profile Completion</div>
    <div class="pc-head">
      <div class="pc-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>
      </div>
      <div class="pc-meta">
        <div class="pc-name" [title]="business.businessName">{{ business.businessName }}</div>
        <!-- Shimmer instead of a misleading 0% until the % call returns -->
        <div class="pc-pct" *ngIf="completePercentage !== null">{{ percent }}%</div>
        <div class="sk sk-pct" *ngIf="completePercentage === null"></div>
      </div>
    </div>
    <div class="pc-track" role="progressbar" [attr.aria-valuenow]="percent" aria-valuemin="0" aria-valuemax="100">
      <div class="pc-fill" [style.width.%]="completePercentage === null ? 0 : percent"></div>
    </div>
    <button *ngIf="!isComplete" type="button" class="pc-btn" (click)="editProfile.emit()">Complete Profile</button>
    <!-- 100%: success note in the button's slot so the card keeps its height -->
    <div *ngIf="isComplete" class="pc-done">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>
      Your profile is completed
    </div>
  </div>

  <!-- Quick Actions -->
  <div class="ac-card ac-pad">
    <div class="ac-title">Quick Actions</div>
    <button type="button" class="qa-item" (click)="postJob.emit()">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>
      Post a Job
      <svg class="qa-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg>
    </button>
    <button type="button" class="qa-item" (click)="editProfile.emit()">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"/></svg>
      Edit Company Profile
      <svg class="qa-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg>
    </button>
    <button type="button" class="qa-item" (click)="manageEmployees.emit()">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><line x1="19" y1="8" x2="19" y2="14"/><line x1="22" y1="11" x2="16" y2="11"/></svg>
      Manage Employees
      <svg class="qa-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg>
    </button>
    <button type="button" class="qa-item" (click)="analytics.emit()">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>
      Analytics (Admin Center)
      <svg class="qa-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg>
    </button>
    <button type="button" class="qa-item" (click)="adminCenter.emit()">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="12" cy="12" r="3"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14M4.93 4.93a10 10 0 0 0 0 14.14"/></svg>
      Admin Center
      <svg class="qa-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg>
    </button>
  </div>

  <!-- Page Health -->
  <div class="ac-card ac-pad">
    <div class="ac-title">Page Health</div>

    <div class="ph-item">
      <div class="ph-dot" [class.ph-dot--done]="hasDescription"></div>
      <div class="ph-text">Company description</div>
      <svg *ngIf="hasDescription" class="ph-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-label="Done"><polyline points="20 6 9 17 4 12"/></svg>
      <button *ngIf="!hasDescription" type="button" class="ph-btn" (click)="openEditor.emit('about')">Add</button>
    </div>

    <div class="ph-item">
      <div class="ph-dot" [class.ph-dot--done]="hasLinkedin"></div>
      <div class="ph-text">LinkedIn profile</div>
      <svg *ngIf="hasLinkedin" class="ph-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-label="Done"><polyline points="20 6 9 17 4 12"/></svg>
      <button *ngIf="!hasLinkedin" type="button" class="ph-btn" (click)="openEditor.emit('social')">Add</button>
    </div>

    <div class="ph-item">
      <div class="ph-dot" [class.ph-dot--done]="hasCover"></div>
      <div class="ph-text">Cover photo</div>
      <svg *ngIf="hasCover" class="ph-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-label="Done"><polyline points="20 6 9 17 4 12"/></svg>
      <button *ngIf="!hasCover" type="button" class="ph-btn" (click)="uploadCover.emit()">Upload</button>
    </div>

    <div class="ph-item">
      <div class="ph-dot" [class.ph-dot--done]="hasStateOfIncorporation"></div>
      <div class="ph-text">State of Incorporation</div>
      <svg *ngIf="hasStateOfIncorporation" class="ph-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-label="Done"><polyline points="20 6 9 17 4 12"/></svg>
      <button *ngIf="!hasStateOfIncorporation" type="button" class="ph-btn" (click)="openEditor.emit('details')">Add</button>
    </div>

    <div class="ph-item">
      <div class="ph-dot" [class.ph-dot--done]="hasServices"></div>
      <div class="ph-text">Services listed</div>
      <svg *ngIf="hasServices" class="ph-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-label="Done"><polyline points="20 6 9 17 4 12"/></svg>
      <button *ngIf="!hasServices" type="button" class="ph-btn" (click)="addServices.emit()">Add</button>
    </div>
  </div>

</ng-container>
